var _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6004 21.6007V14.5687C21.6004 11.1127 20.8564 8.47266 16.8244 8.47266C14.8804 8.47266 13.5844 9.52866 13.0564 10.5367H13.0084V8.78466H9.19238V21.6007H13.1764V15.2407C13.1764 13.5607 13.4884 11.9527 15.5524 11.9527C17.5924 11.9527 17.6164 13.8487 17.6164 15.3367V21.5767H21.6004V21.6007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71191 8.78418H6.69591V21.6002H2.71191V8.78418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70439 2.40039C3.43239 2.40039 2.40039 3.43239 2.40039 4.70439C2.40039 5.97639 3.43239 7.03239 4.70439 7.03239C5.97639 7.03239 7.00839 5.97639 7.00839 4.70439C7.00839 3.43239 5.97639 2.40039 4.70439 2.40039Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic-linkedin.67307e5bd40c3fe7236f5582a60b11a1.svg";
export { ForwardRef as ReactComponent };